import React from 'react';
import './temp.css';
const Temp = () => {
  return <div className="temp-container">임시페이지입니다.</div>;
};

export default Temp;
